"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _params = require("hub-http/helpers/params");

var _I18n = _interopRequireDefault(require("I18n"));

var _enviro = _interopRequireDefault(require("enviro"));

var _localSettings = _interopRequireDefault(require("crm_internal/config/localSettings"));

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

function _default(_ref) {
  var eventName = _ref.eventName,
      localSetting = _ref.localSetting,
      eventId = _ref.eventId,
      portalId = _ref.portalId,
      eventType = _ref.eventType;
  var eventValue;

  if (eventType === 'FLAG') {
    if (localSetting) {
      _localSettings.default.set(localSetting, true);
    }

    eventValue = true;
  } else if (eventType === 'DATE') {
    var date = _I18n.default.moment.utc().startOf('day').valueOf();

    var localDate = _localSettings.default.get(localSetting);

    if (!localDate || _I18n.default.moment.utc(localDate).startOf('day').valueOf() !== date) {
      _localSettings.default.set(localSetting, date);

      eventValue = date;
    } else {
      return;
    }
  }

  if (_enviro.default.getShort() === 'prod') {
    _user.default.then(function (user) {
      var params = {
        _n: eventId,
        _a: portalId,
        email: user.get('email'),
        crm_hub_id: _hubspot.default.get(),
        sales_product_conversion: true
      };
      var firstname = user.get('first_name');

      if (firstname) {
        params.firstname = firstname;
      }

      var lastname = user.get('last_name');

      if (lastname) {
        params.lastname = lastname;
      }

      params[eventName] = eventValue;
      var url = "https://track.hubspot.com/v1/event?" + (0, _params.stringify)(params);
      var pixel = new Image();
      pixel.src = url;
      return pixel;
    }).done();
  }
}

module.exports = exports.default;